<span class="social-item-wrapper">
  <a href="https://www.twitter.com/Identibase/"
    target="_blank"
    class="socials-icon">
    <div class="blob-wrapper" [ngClass]="badgeStyleClass"
     [ngStyle]="{ 'width': badgeWrapperSize, 'height': badgeWrapperSize }">
      <svg  class="blob" [ngClass]="badgeStyleClass"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="252"
            height="240"
            viewBox="0 0 252 240">
        <defs>
          <path id="a-3"
                d="M180.899 10.094C147.354-9.33 46.9-3.935 12.816 54.88c-34.084 58.816 6.385 145.87 44.786 168.083 65.29 37.77 126.894 9.892 160.978-48.923 34.084-58.816 28.418-125.725-37.681-163.946">
          </path>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(7)">
          <mask id="b-3" fill="#fff">
            <use xlink:href="#a-3"></use>
          </mask>
          <use fill-rule="nonzero" xlink:href="#a-3"></use>
          <g fill-rule="nonzero" mask="url(#b-3)">
            <path d="M-7-1h253v241H-7z"></path>
          </g>
        </g>
      </svg>
      <div class="blob-content">
        <fa-icon [ngStyle]="{ 'font-size': badgeIconSize }" [icon]="['fab', 'twitter']"></fa-icon>
      </div>
    </div>
  </a>
</span>
